//全局使用的一些函数
import moment from 'moment'
import router from '../../router'
export default {
  install(Vue) {

    //================ 工具相关
    //返回上一页
    Vue.prototype.backToPrevpage = function () {
      if (history.length > 1) {
        router.go(-1);
      } else {
        router.push({ path: '/' });
      }
    };

    //复制到剪贴板
    Vue.prototype.copyToClipboard = function (content) {

      if (window.clipboardData) {
        window.clipboardData.setData('text', content);
      } else {
        (function (content) {
          document.oncopy = function (e) {
            e.clipboardData.setData('text', content);
            e.preventDefault();
            document.oncopy = null;
          }
        })(content);
        document.execCommand('Copy');
      }
    };

    //页面滚动到，全局函数
    //https://stackoverflow.com/questions/21474678/scrolltop-animation-without-jquery
    Vue.prototype.scrollToTop = function (duration = 500, targettop = 100, linear = false) {
      // cancel if already on top
      if (document.scrollingElement.scrollTop === targettop) return;
      if (linear) {
        const cosParameter = document.scrollingElement.scrollTop - targettop;
        let scrollY = cosParameter, oldTimestamp = null;
        let firstTimestamp = null;//通过时间戳判断何时终止
        function step(newTimestamp) {
          if (firstTimestamp === null) {
            firstTimestamp = newTimestamp;
          }
          if (oldTimestamp !== null) {
            scrollY -= cosParameter * (newTimestamp - oldTimestamp) / duration;
            //if (scrollY > -10 && scrollY < 10) return document.scrollingElement.scrollTop = targettop;
            if (oldTimestamp - firstTimestamp >= duration) return document.scrollingElement.scrollTop = targettop;
            document.scrollingElement.scrollTop = targettop + scrollY;
          }
          oldTimestamp = newTimestamp;
          window.requestAnimationFrame(step);
        }
        window.requestAnimationFrame(step);
      } else {
        const cosParameter = (targettop - document.scrollingElement.scrollTop) / 2;
        let scrollCount = 0, oldTimestamp = null;
        function step(newTimestamp) {
          if (oldTimestamp !== null) {
            // if duration is 0 scrollCount will be Infinity
            scrollCount += Math.PI * (newTimestamp - oldTimestamp) / duration;
            if (scrollCount >= Math.PI) return document.scrollingElement.scrollTop = targettop;
            document.scrollingElement.scrollTop = targettop - (cosParameter + cosParameter * Math.cos(scrollCount));
          }
          oldTimestamp = newTimestamp;
          window.requestAnimationFrame(step);
        }
        window.requestAnimationFrame(step);
      }
    };

    //通过经纬度计算距离，返回公里数
    Vue.prototype.calcDistance = function (lat1, lng1, lat2, lng2) {
      function Rad(d) {
        return d * Math.PI / 180.0;//经纬度转换成三角函数中度分表形式。
      }
      var radLat1 = Rad(lat1);
      var radLat2 = Rad(lat2);
      var a = radLat1 - radLat2;
      var b = Rad(lng1) - Rad(lng2);
      var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) +
        Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
      s = s * 6378.137;// EARTH_RADIUS;
      s = Math.round(s * 10000) / 10000; //输出为公里
      //s=s.toFixed(4);
      return s;
    };



    //美化价格的显示 num 待美化的价格 fixed 几位小数 round 四舍五入 thousand 千位符
    Vue.prototype.priceSexy = function (num, fixed = 2, round = true, thousand = false) {
      if (isNaN(num)) {
        return num;
      }
      if (fixed >= 0) {
        if (round) {
          num = (Number(num)).toFixed(fixed);
        } else {
          num = (Math.floor(num * 100) / 100).toFixed(fixed);
        }
      }
      if (thousand) {
        var numarr = num.split(".");
        if (numarr.length) {
          num = (numarr[0] || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
        }
        if (numarr.length > 1 && numarr[1] != "") {
          num = "" + num + "." + numarr[1];
        }
      }
      return num;
    };


    //格式化时间 时间戳、Date 都行
    Vue.prototype.dateformat = function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
      if (dataStr == '' || dataStr == null || dataStr == 'Invalid date') {
        return ''
      } else if (dataStr != '') {
        if (dataStr.toString().length < 13) {
          dataStr *= 1000;
        }
        return moment(dataStr).format(pattern);
      }
    }

    //只能输入正整数的数字
    Vue.prototype.integer = function (val) {
      if (val == '' || val == null || val == undefined) {
        return 0
      } else {
        return /^[0-9]*$/.test(parseInt(val))
          ? String(parseInt(val)).replace('.', '')
          : ''
      }
    }

    //只能输入正整数的数字且数字不能操作
    Vue.prototype.integernum = function (val, max = 100, min = 1) {
      if (/^[0-9]*$/.test(parseInt(val))) {
        // console.log(String(parseInt(val)).replace('.', ''), 123123)
        // return String(parseInt(val)).replace('.', '')
        if (parseInt(val) > max) {
          return 100
        } else if (parseInt(val) < min) {
          return 1
        } else {
          return String(parseInt(val)).replace('.', '')
        }
      }
      // return /^[0-9]*$/.test(parseInt(val))
      //   ? String(parseInt(val)).replace('.', '')
      //   : ''
    }



    //数字只保留两位小数
    Vue.prototype.inttwo = function (val) {
      return val.toFixed(2)
    }



    //文件大小设置
    Vue.prototype.filesize = function (bytes, decimals = 2) {
      if (bytes) {
        if (bytes === 0) return '0'
        const k = 1024
        const dm = decimals < 0 ? 0 : decimals
        const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        const i = Math.floor(Math.log(bytes) / Math.log(k))
        // console.log(parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i],'parseFloat')
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
      } else {
        return ''
      }
    }


    // 获取文件后缀设置
    Vue.prototype.filename = function (filename) {
      if (filename) {
        const match = filename.match(/\.([0-9a-z]+)(?:[\?#]|$)/i);
        return match ? match[1].toLowerCase() : '';
      } else { 
        return ''
      }
    }
    //================ 业务相关
    // 去掉文字前后空格, 特殊字符

    Vue.prototype.bytelength = function (value, len) {
      const encoder = new TextEncoder();
      const encodedString = encoder.encode(value);
      let isExceedLimit = encodedString.length > len;
      return isExceedLimit;
    }
    // 去掉文字前后空格, 特殊字符
    Vue.prototype.formateText = function (value) {
      // value = value.replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/g, '').replace(/\s/g, "");
      // value = value.replace(/[`~@#$%^……&*{}|/'\\[\]@#￥%&{}|【】]/g, '').replace(/\s/g, "");
      // value = value.replace(/[`~@#$%^……&*{}|/'\\[\]@#￥%&{}|【】]/g, '');
      value = value.replace(/[`@#$^……|'\\[\]@#￥|【】]/g, '');
      return value;
    }

    //身高校验（71~249CM）
    Vue.prototype.checkHeight = function (height) {
      if (parseInt(height) >= 250) {
        return false;
      } else if (parseInt(height) <= 70) {
        return false;
      } else if (parseInt(height) === 0) {
        return false;
      } else {
        return true;
      }
    }

    //体重校验（12KG~200KG）
    Vue.prototype.checkWeight = function (Weight) {
      if (parseInt(Weight) > 200) {
        return false;
      } else if (parseInt(Weight) < 12) {
        return false;
      } else if (parseInt(Weight) === 0) {
        return false;
      } else {
        return true;
      }
    }

    //手机号校验
    Vue.prototype.checkPhone = function (phone) {
      // let reg = /^1[3456789]\d{9}$/
      let reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;    //11位手机号码正则
      return reg_tel.test(phone);
    }

    //邮箱校验
    Vue.prototype.checkEmail = function (email) {
      let reg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return reg.test(email);
    }
    // 台湾居民来往大陆通行证
    Vue.prototype.isTWCard = function (card) {
      // 规则： 新版8位或18位数字， 旧版10位数字 + 英文字母
      // 样本： 12345678 或 1234567890B
      var reg = /^\d{8}|^[a-zA-Z0-9]{10}|^\d{18}$/;
      return reg.test(card);
    }
    // 港澳台居民来往内地通行证
    Vue.prototype.isHKCard = function (card) {
      // 规则： H/M + 10位或6位数字
      // 样本： H1234567890
      // var reg = /^([A-Z]\d{6,10}(\(\w{1}\))?)$/;
      var reg = /^[0-9a-zA-Z]{1,18}$/;
      return reg.test(card);
    }
    // 校验护照
    Vue.prototype.checkPassPortCard = function (card) {
      // 护照
      // 规则： 14/15开头 + 7位数字, G + 8位数字, P + 7位数字, S/D + 7或8位数字,等
      // 样本： 141234567, G12345678, P1234567
      var reg = /^([a-zA-z]|[0-9]){5,17}$/;
      return reg.test(card);
    }
    //身份证校验
    // 函数参数必须是字符串，因为二代身份证号码是十八位，而在javascript中，十八位的数值会超出计算范围，造成不精确的结果，导致最后两位和计算的值不一致，从而该函数出现错误。
    // 详情查看javascript的数值范围
    Vue.prototype.checkIDCard = function (idcode) {
      // 加权因子
      var weight_factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      // 校验码
      var check_code = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"];

      var code = idcode + "";
      var last = idcode[17]; //最后一位

      var seventeen = code.substring(0, 17);

      // ISO 7064:1983.MOD 11-2
      // 判断最后一位校验码是否正确
      var arr = seventeen.split("");
      var len = arr.length;
      var num = 0;
      for (var i = 0; i < len; i++) {
        num = num + arr[i] * weight_factor[i];
      }

      // 获取余数
      var resisue = num % 11;
      var last_no = check_code[resisue];

      // 格式的正则
      // 正则思路
      /*
    第一位不可能是0
    第二位到第六位可以是0-9
    第七位到第十位是年份，所以七八位为19或者20
    十一位和十二位是月份，这两位是01-12之间的数值
    十三位和十四位是日期，是从01-31之间的数值
    十五，十六，十七都是数字0-9
    十八位可能是数字0-9，也可能是X
    */
      var idcard_patter =
        /^[1-9]\d{5}(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[1-2]\d|3[0-1])\d{3}[\dX]$/;

      // 判断格式是否正确
      var format = idcard_patter.test(idcode);
      // 返回验证结果，校验码和格式同时正确才算是合法的身份证号码
      return last === last_no && format ? true : false;
    }

    //判断环境
    Vue.prototype.browser = function (ua) {
      var a = new Object()
      var b = {
        //micromessenger: /micromessenger/.test(ua),
        msie: /msie/.test(ua) && !/opera/.test(ua),
        opera: /opera/.test(ua),
        safari: /webkit/.test(ua) && !/chrome/.test(ua),
        firefox: /firefox/.test(ua),
        edge: /edge/.test(ua),
        trident: /trident/.test(ua),
        chrome: /chrome/.test(ua)
      }
      var vMark = ""
      for (var i in b) {
        if (b[i]) { vMark = i; break }//"safari" == i ? "version" : i;
      }
      b.version = vMark && RegExp("(?:" + vMark + ")[\\/: ]([\\d.]+)").test(ua) ? RegExp.$1 : "0"
      b.ie = b.msie
      b.ie6 = b.msie && parseInt(b.version, 10) == 6
      b.ie7 = b.msie && parseInt(b.version, 10) == 7
      b.ie8 = b.msie && parseInt(b.version, 10) == 8

      //if(vMark == "trident") vMark = "ie11";

      a.b = vMark
      a.v = b.version
      a.m = /mobile/i.test(ua)
      a.wx = /MicroMessenger/i.test(ua)
      a.wxminiprogram = /miniProgram/i.test(ua)
      a.giantapp = /giantapp/i.test(ua)
      a.giantevapp = /giantevapp/i.test(ua)
      a.giantopoapp = /giantopoapp/i.test(ua)
      a.ios = /\(i[^;]+;( U;)? CPU.+Mac OS X/i.test(ua)

      return a
    }(window.navigator.userAgent.toLowerCase());


    Vue.prototype.includeSpecial = function (value) {
      if (!value) {
        return
      }
      // eslint-disable-next-line
      const regStr = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi
      return value.replace(regStr, '')
    }

    Vue.prototype.time = function (value, type) {
      // 给定的时间点（例如：2024年12月17日 12:00）
      let givenDate = new Date(value)
      // 计算倒计时的结束时间（30天后）
      let countdownDate = new Date(givenDate.getTime() + (30 * 24 * 60 * 60 * 1000)) // 60天的毫秒数
      // 输出倒计时结束时间
      // console.log('倒计时结束时间：', countdownDate.toLocaleString())
      // 当前时间
      let currentTime = new Date()
      // 计算剩余的时间差
      let timeDifference = countdownDate - currentTime
      if (timeDifference > 0) {
        // 如果剩余时间大于0，则输出倒计时
        let days = Math.floor(timeDifference / (1000 * 60 * 60 * 24))
        let hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        let minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60))
        let seconds = Math.floor((timeDifference % (1000 * 60)) / 1000)
        if (type) {
          return days
        } else {
          return `${days}天`
        }
        // return `${days}天 ${hours}小时 ${minutes}分钟 ${seconds}秒`
      } else {
        return `0天`
      }
    }
  }
}
